import { Factory } from 'rosie';
import './lib/uuid';

Factory.define('Attachment').extend('Uuid');
Factory.define('SnippetAttachment')
  .extend('Attachment')
  .attr('type', 'SNIPPET_ATTACHMENT');



// WEBPACK FOOTER //
// ./factories/attachment_factory.js